import { render, staticRenderFns } from "./DeclarationLabelPrintTable.vue?vue&type=template&id=2eb16145&"
import script from "./DeclarationLabelPrintTable.vue?vue&type=script&lang=js&"
export * from "./DeclarationLabelPrintTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports